import { createResourceCollection } from '@/request'
import { PushNotificationSettings } from '@/types/push_notification_settings'

export const pushNotificationSettingsCollection =
  createResourceCollection<PushNotificationSettings>({
    name: 'pushNotificationSettings',
    selector: (state) => state.pushNotificationSettings,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    computedId: (_) => '_', // Need to define for a singleton resource
  })

export const pushNotificationSettingsCollectionReducer =
  pushNotificationSettingsCollection.slice.reducer
